<template>
  <div class="hero">
    <div class="hero__content">
        <!-- <h3>Online Fitness</h3> -->
        <h1>Workouts Tracker.</h1>
        <!-- <p>Track exercise history and metrics</p> -->
        <p> Online fitness program that meet your individual needs.
            Discover new ways to conquer your goals find a way to improve yourself.
        </p>
          <!-- Stick with the plan
          and achieve your fitness goals. -->
        <a href= "#memberships" class="home_button"> Learn more </a>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
